import { useMutation } from 'react-query';
import axios from 'axios';
import { RatingAPI } from '../../constants/API';
import { RatingWorkplaceParams } from '../../types/Rating/RatingTypes';
import { formatWorkplaceNumber } from '../../utils/Rating/parseRatingParams';

type SaveRatingPayload = RatingWorkplaceParams & {
  rating: number;
  employeeId?: number;
  branchId?: number;
  queueId?: number;
};

export const useSaveRating = () => {
  return useMutation((payload: SaveRatingPayload) =>
    axios.post(RatingAPI.save, {
      branch: payload.branch,
      queue: payload.queue,
      cabinet: formatWorkplaceNumber(payload.cabinet),
      window: formatWorkplaceNumber(payload.window),
      rating: payload.rating,
      branchId: payload.branchId,
      queueId: payload.queueId,
      employeeId: payload.employeeId
    })
  );
};
